import * as ActionTypes from "constants/ActionTypes";

export const setViewportDimensions = (dimensions) => ({
  dimensions,
  type: ActionTypes.SET_VIEWPORT_DIMENSIONS,
});

export const setViewportPixelRatio = (pixelRatio) => ({
  pixelRatio,
  type: ActionTypes.SET_VIEWPORT_PIXEL_RATIO,
});
